import { Stack, Typography } from '@mui/material';
import { ProductGroups } from 'enums';
import React from 'react';
import { ProductMappedColors } from 'theme';
import { makeStyles } from 'tss-react/mui';

interface Props {
  productGroup: ProductGroups | undefined;
  productGroupName: string;
  center?: boolean;
  hidden?: boolean;
  children?: React.ReactNode;
}

const ProductGroup: React.FC<Props> = ({ productGroup, productGroupName, center, hidden, children }) => {
  const color = ProductMappedColors[productGroup || 'default'];
  const { classes } = useStyles({ color });

  const hrBoosterLogo = '/dashboard/images/logos/hr_booster_logo_short.svg';
  const leadBoosterLogo = '/dashboard/images/logos/lead_booster_logo_short.svg';
  const paiLogo = '/dashboard/images/logos/product_logo_white.svg';

  const logo = productGroup === ProductGroups.HR_BOOSTER ? hrBoosterLogo : productGroup === ProductGroups.LEAD_BOOSTER ? leadBoosterLogo : paiLogo;
  const logoAlt = productGroup === ProductGroups.HR_BOOSTER ? 'HR Booster' : productGroup === ProductGroups.LEAD_BOOSTER ? 'Lead Booster' : 'PAI';

  return (
    <div style={{ display: !hidden ? 'block' : 'none' }}>
      <div className={classes.productGroupContainer}>
        <img className={classes.productGroupLogo} src={logo} alt={logoAlt} />
        <Typography className={classes.productGroupName}>{productGroupName}</Typography>
        <span className={classes.productGroupLine} />
      </div>
      <Stack
        className={classes.productsContainer}
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent={center ? 'center' : 'flex-start'}
        flexWrap="wrap"
      >
        {children}
      </Stack>
    </div>
  );
};

const useStyles = makeStyles<{ color: string }>()((theme, { color }) => ({
  productGroupContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '16px',
  },
  productGroupLogo: {
    height: '28px',
    width: 'auto',
  },
  productGroupName: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
  },
  productGroupLine: {
    flex: 1,
    height: '3px',
    background: color,
    opacity: 0.25,
    borderRadius: '2px',
  },
  productsContainer: {
    minHeight: 0,
    gap: '20px',
  },
}));

export default ProductGroup;
